export default __webpack_public_path__ + "static/media/include_2_male@3x.680f2ded.jpg";